import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {commitsAppBuilder} from './config/app-builder'
import {createCommitsRoutes} from './routes/create-commits-routes'
import {commitsRouteComponents} from './routes/route-components'

export const commitsApp = commitsAppBuilder.createDataRouterAppFromRoutes(
  createCommitsRoutes(commitsAppBuilder, commitsRouteComponents),
)
registerDataRouterApp(commitsApp)
